import { BufferGeometry, CylinderGeometry, SphereGeometry } from 'three';
import { mergeGeometries } from 'three/examples/jsm/utils/BufferGeometryUtils.js';
import { SCALE_IN_TO_UNIT } from '../../types';

function buildDomeRivet(headDiaIn: number, shaftDiaIn: number, shaftLenIn: number): BufferGeometry {
  const headR = (headDiaIn * 1.6) / 2;
  const shaftR = shaftDiaIn / 2;
  const head = new SphereGeometry(headR, 12, 6, 0, Math.PI * 2, 0, Math.PI / 2);
  const shaft = new CylinderGeometry(shaftR, shaftR, shaftLenIn, 8);
  shaft.translate(0, -shaftLenIn / 2, 0);
  const merged = mergeGeometries([head, shaft], false) as BufferGeometry;
  merged.scale(SCALE_IN_TO_UNIT, SCALE_IN_TO_UNIT, SCALE_IN_TO_UNIT);
  return merged;
}

function buildCountersunkRivet(
  headDiaIn: number,
  shaftDiaIn: number,
  shaftLenIn: number,
): BufferGeometry {
  const headTop = headDiaIn / 2;
  const headBot = shaftDiaIn / 2;
  const head = new CylinderGeometry(headTop, headBot, 0.05, 12);
  head.translate(0, -0.025, 0);
  const shaft = new CylinderGeometry(shaftDiaIn / 2, shaftDiaIn / 2, shaftLenIn, 8);
  shaft.translate(0, -shaftLenIn / 2 - 0.05, 0);
  const merged = mergeGeometries([head, shaft], false) as BufferGeometry;
  merged.scale(SCALE_IN_TO_UNIT, SCALE_IN_TO_UNIT, SCALE_IN_TO_UNIT);
  return merged;
}

export const rivetDome3_16 = (): BufferGeometry => buildDomeRivet(3 / 16, 3 / 16, 0.4);
export const rivetDome1_4 = (): BufferGeometry => buildDomeRivet(1 / 4, 1 / 4, 0.5);
export const rivetCountersunk3_16 = (): BufferGeometry =>
  buildCountersunkRivet((3 / 16) * 1.6, 3 / 16, 0.4);
export const rivetCountersunk1_4 = (): BufferGeometry =>
  buildCountersunkRivet((1 / 4) * 1.6, 1 / 4, 0.5);
